import {
  GetApplicationInterviewsQuery,
  AtsInterviewAttendeeStatusesEnum,
  AtsInterviewOptionsTypesEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type AtsInterview = NonNullable<
  NonNullable<
    NonNullable<GetApplicationInterviewsQuery['ats']>['interviewsConnection']
  >['nodes']
>[0]

export const MeetingStartBufferMinutes = 60

export const isInterviewActive = (interview: AtsInterview): boolean => {
  return interview.status === 'processing' || interview.status === 'scheduled'
}

export const attendeStatusLabel = (status: AtsInterviewAttendeeStatusesEnum, fullName: string) => {
  switch (status) {
    case 'needs_action':
    case 'unknown':
    case 'tentative':
      return i18n.t('ats.interview_status.attendee_status.needs_action', { fullName })
    case 'accepted':
      return i18n.t('ats.interview_status.attendee_status.accepted', { fullName })
    case 'declined':
      return i18n.t('ats.interview_status.attendee_status.declined', { fullName })
    default:
      return fullName
  }
}

export const interviewTypeLabel = (type: AtsInterviewOptionsTypesEnum): string => {
  switch (type) {
    case 'online':
      return i18n.t('ats.interview_status.interview_type.online')
    case 'telephone':
      return i18n.t('ats.interview_status.interview_type.telephone')
    case 'in_person':
      return i18n.t('ats.interview_status.interview_type.in_person')
  }
}

export const attendeStatusBadge = (status: AtsInterviewAttendeeStatusesEnum) => {
  switch (status) {
    case 'unknown':
    case 'needs_action':
    case 'tentative':
      return {
        icon: 'question',
        position: 'top',
        backgroundColor: 'peach1000',
        color: 'grey000White',
      } as const
    case 'declined':
      return {
        icon: 'cross',
        position: 'top',
        backgroundColor: 'radicalRed1000',
        color: 'grey000White',
      } as const
    case 'accepted':
      return {
        icon: 'check',
        position: 'top',
        backgroundColor: 'lime1000',
        color: 'grey000White',
      } as const
    default:
      return undefined
  }
}
